module.exports = __webpack_public_path__ + "static/img/race2019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/race2019.jpg
// module id = Vn6S
// module chunks = 0